import { baseAPIUrl } from "./urlConstants"

export const REACT_APP_BETA = baseAPIUrl.includes("beta")
export const NODE_ENV = process.env.NODE_ENV